import { render } from "./domainList.vue?vue&type=template&id=3901c3de&scoped=true"
import script from "./domainList.vue?vue&type=script&lang=js"
export * from "./domainList.vue?vue&type=script&lang=js"

import "./domainList.vue?vue&type=style&index=0&id=3901c3de&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3901c3de"],['__file',"resources/js/pages/bulletin/domainList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3901c3de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3901c3de', __exports__)) {
    console.log('reload')
    api.reload('3901c3de', __exports__)
  }
  
  module.hot.accept("./domainList.vue?vue&type=template&id=3901c3de&scoped=true", () => {
    console.log('re-render')
    api.rerender('3901c3de', render)
  })

}


export default __exports__